import { Edit } from "@mui/icons-material";
import { Box, IconButton } from "@mui/material";
import { KeyDriveBodyMin } from "../../../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMin";
import React from "react";

interface IConcludedStepsVisual {
    contentVisual?: string;
    icon: React.ReactNode;
    titleText: string;
    contentText: string;
    step: number;
    setStep: (set: number) => void;
}

export default function ConcludedStepsVisual({
    icon,
    contentVisual,
    titleText,
    contentText,
    step,
    setStep
}: IConcludedStepsVisual): JSX.Element {
    return (
        <Box
            borderBottom="1px solid #DEE8EE"
        >
            <Box
                display="flex"
                justifyContent="space-between"
                padding="8px"
            >
                <Box
                    display="flex"
                    alignItems="center"
                >
                    { icon }
                    <KeyDriveBodyMin
                        color="#4E82A4"
                        needBold={true}
                        needEllipses={false}
                        text={titleText}
                    />
                </Box>
                <IconButton
                    onClick={() => setStep(step)}
                >
                    <Edit sx={{ color: "#22638D" }} />
                </IconButton>
            </Box>
            <Box
                display="flex"
                justifyContent="space-between"
                paddingX="8px"
                paddingBottom="4px"
            >
                <KeyDriveBodyMin
                    color="#C0C0C0"
                    needBold={false}
                    needEllipses={false}
                    text={contentText}
                />
                <KeyDriveBodyMin
                    color="#2D2D2D"
                    needBold={false}
                    needEllipses={false}
                    text={contentVisual!}
                />
            </Box>
        </Box>
    )
}